var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"d-flex"},[_c('p',{staticClass:"page-title my-auto"},[_vm._t("title")],2),_vm._v(" "),_c('div',{staticClass:"ml-auto my-auto"},[_vm._t("action")],2)]),_vm._v(" "),_c('div',{staticClass:"mt-4"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }